// extracted by mini-css-extract-plugin
module.exports = {"arrows":"SwiperArrows_arrows_D0P3s","arrowButton":"SwiperArrows_arrowButton_3G-O3"};